import React from 'react';
import { interpolate, Easing } from 'remotion';
import { TransitionInEffect } from '@/player-config/src/types/transitions';

export function getTransitionPageInStyles({
  fps,
  frame,
  animationType
}: {
  fps: number;
  frame: number;
  animationType: TransitionInEffect;
}): React.CSSProperties {
  switch (animationType) {
    case TransitionInEffect.Fade: {
      const animationDurationSeconds = 0.2;
      const animationDuration = Math.ceil(animationDurationSeconds * fps);
      const progress = interpolate(frame, [0, animationDuration], [0, 1], {
        easing: Easing.out(Easing.ease),
        extrapolateLeft: 'clamp',
        extrapolateRight: 'clamp'
      });

      return {
        opacity: progress
      };
    }

    case TransitionInEffect.SlideUp: {
      const animationDurationSeconds = 0.2;
      const animationDuration = Math.ceil(animationDurationSeconds * fps);
      const slideDistance = 12;
      const progress = interpolate(frame, [0, animationDuration], [0, 1], {
        easing: Easing.out(Easing.ease),
        extrapolateLeft: 'clamp',
        extrapolateRight: 'clamp'
      });
      const yOffset = slideDistance * (1 - progress);
      return {
        transform: `translateY(${yOffset}px)`,
        opacity: progress
      };
    }

    case TransitionInEffect.Spring: {
      const animationDurationSeconds = 0.3;
      const animationDuration = Math.ceil(animationDurationSeconds * fps);
      const startScale = 0.8;
      const endScale = 1.0;
      const progress = interpolate(frame, [0, animationDuration], [0, 1], {
        easing: Easing.elastic(1.5),
        extrapolateLeft: 'clamp',
        extrapolateRight: 'clamp'
      });
      const scale = startScale + (endScale - startScale) * progress;
      return {
        transform: `scale(${scale})`,
        opacity: progress
      };
    }

    default:
      return {};
  }
}
